<template>
  <div>
    <div class="home">
      <NavBar :index="2" />
      <div class="w" id="promotion">
        <img
          style="padding-top: 30px; padding-bottom: 200px; margin: 0 auto"
          src="@/assets/img/pc/talents.png"
          alt=""
        />

        <div id="money"></div>
      </div>
    </div>
    <Footer showBackgroundColor></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import { isMobile } from "@/assets/js/index";

export default {
  name: "page2",
  components: {
    NavBar,
    Footer,
  },
  mounted() {
    if (isMobile()) {
      this.$router.replace({ name: "mobile" });
    }
  },
};
</script>
